<template>
  <div
    @click="getViewProduct(product._id, product.providerId)"
    class="card-product curp"
    :class="{
      'card-lg-v': size == 'lg',
      'card-md-v': size == 'md',
      'card-sm-v': size == 'sm',
      'card-sm-v-colum': size == 'sm-column',
      'bg-white': background == 'white'
    }"
  >
    <div class="header-product">
      <!-- aqui la etiqueta de promocion. -->
      <div class="badge-overlay" v-if="promo">
        <span
          class="product-badge w-60"
          :class="{
            offert: typeBadge === 'offert',
            hight: typeBadge === 'hight',
            info: typeBadge === 'info',
            important: typeBadge === 'important'
          }"
        >
          Special Combo!
        </span>
      </div>

      <div class="carousel-products">
        <LazyImage
          :src="product.images[0] || noImage"
          :alt="`${product.name}`"
          imgClasses="responsive-image"
        />
      </div>
    </div>

    <h4 class="title-product">
      {{ product.name }}
    </h4>

    <div class="excerpt-product" v-if="excerpt">
      <p v-if="product.short_description">
        {{ product.short_description }}
      </p>

      <p v-else-if="product.description">
        {{ product.description }}
      </p>

      <p v-else>
        An experience that will make you enjoy incredible moments and create
        unforgettable memories, transforming the way you see the world. Live
        something unique!
      </p>
    </div>

    <div class="experience-info-li">
      <div class="content-info-li" v-if="source === 'RHOMTRIP'">
        <div>
          <i class="flaticon-employees "></i>
          <span>{{ product.passengers.maximum }} PAX</span>
        </div>
      </div>

      <div class="content-info-li" v-if="source === 'RHOMTRIP'">
        <div>
          <i class="flaticon-briefcase"></i>
          <span> {{ product.bags.maximum }} Bags</span>
        </div>
      </div>

      <div
        class="content-info-li"
        v-if="source === 'RHOMTRIP' && product.type === 'TOUR'"
      >
        <div>
          <i class="flaticon-wall-clock"></i>
          <span>
            {{ product.duration.value }}
            {{
              getUnitTime(product.duration.unit, product.duration.value)
            }}</span
          >
        </div>
      </div>

      <div
        class="content-info-li"
        v-if="source === 'VENTRATA' && product.duration"
      >
        <div>
          <i class="flaticon-wall-clock"></i>

          <span>
            {{ product.duration }}
          </span>
        </div>
      </div>

      <!-- <div class="content-info-li" v-if="commission">
          <el-tooltip content="Commission" placement="bottom">
            <div>
              <i class="flaticon-tools-money-bag"></i>
              <span>10%</span>
            </div>
          </el-tooltip>
        </div> -->
    </div>

    <div class="footer-product" v-if="price && product.pricing">
      <div class="price-card-product w-100">
        From<span>
          {{ product.currency.symbol }}
          {{ product.pricing.amount }}
          {{ product.currency.code }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import { BCarousel } from "bootstrap-vue";
export default {
  name: "cardVertical",
  components: { "b-carousel": BCarousel },

  props: {
    product: {
      type: Object,
      required: false,
      default: null,
      description: ""
    },

    index: {
      type: Number,
      required: false,
      default: null,
      description: "index"
    },
    excerpt: {
      type: Boolean,
      required: false,
      default: false,
      description: "Show excerpt"
    },
    size: {
      type: String,
      required: false,
      default: "",
      description: "lg-md-sm-smcolum"
    },
    badge: {
      type: Boolean,
      required: false,
      default: false,
      description: "Show barge in card"
    },
    classBadge: {
      type: String,
      required: false,
      default: "",
      description: ".important(red)-.offert(orange)-.info(blue light)-"
    },
    price: {
      type: Boolean,
      required: false,
      default: true,
      description: "Show price in card"
    },
    background: {
      type: String,
      required: false,
      default: "transparent",
      description: "back color card"
    },
    promo: {
      type: Boolean,
      required: false,
      default: false,
      description: "Show promotion in card"
    },
    typeBadge: {
      type: String,
      required: false,
      default: "offert",
      description: "badge of the promotions"
    },
    source: {
      type: String,
      required: false,
      default: "RHOMTRIP",
      description: "Source of the product"
    }
  },
  data() {
    return {
      noImage: require("rhomtrip_assets/src/img/no-image-available.png")
    };
  },
  methods: {
    async getViewProduct(productId, providerId = null) {
      if (this.source === "RHOMTRIP") {
        this.$router.push(`/experiences/rhomtrip/${productId}`);
      } else {
        this.$router.push(
          `/experiences/ventrata/${productId}?providerId=${providerId}`
        );
      }
    },
    getUnitTime(unit, value) {
      if ("HOURS" === unit) {
        return value > 1 ? "hours" : "hour";
      } else if ("MINUTES" === unit) {
        return value > 1 ? "Minutes" : "Minute";
      } else if ("DAYS" === unit) {
        return value > 1 ? "days" : "day";
      } else {
        return "";
      }
    }
  }
};
</script>
